import { ModulFState } from "../store";

import { EnvironmentData } from "./types";

export function selectEnvironmentData(state: ModulFState): EnvironmentData {
	return state.environmentData;
}
